<template>
  <div>
    <div :style="'border-radius: 8px; padding: 0.5em; background: ' + color">
      <img v-if="qrCode" style="width: 100%; height: auto;" :src="qrCode.src" />

    </div>

    <div style="padding-top: 0.5em;">

      <el-tooltip v-if="txt" effect="dark" :content="txt" placement="top">
        <el-button class="pull-left" type="text" icon="fa fa-eye" />
      </el-tooltip>
      <el-button class="pull-left" type="text" icon="fa fa-sync" @click="generate" />

      <el-button
        class="pull-right"
        type="primary"
        size="mini"
        icon="fa fa-download"
        round
        @click="downloadFile(qrCode.src)" />

        <switch-input
          v-if="color"
          size="mini"
          v-model="bw"
          on-text="Color"
          off-text="B&amp;W"
          no-form
          @change="bgChanged" />

    </div>

  </div>

</template>


<script>

import kjua from 'kjua'

import ColorsMixins from '@/mixins/ColorsMixins'

export default {
  mixins: [ColorsMixins],

  components: {
    kjua
  },

  props: {
    text: {
      type: String
    },

    color: {
      type: String,
      default: 'inherit'
    },

    bgAlpha: {
      type: [Number, String],
      default: 0.4
    },

    label: {
      type: String,
      default: null
    },

    size: {
      type: Number,
      default: 528
    },

    labelAlpha: {
      type: [Number, String],
      default: 0.8
    },

    logo: {
      type: String,
      default: null
    },

    bwBackground: {
      type: Boolean,
      default: true
    },

    fileName: {
      type: String,
      default: null
    },

    textSize: {
      type: Number,
      default: 6
    }

  },



  watch: {

    text: function (value) {
      this.txt = value
      this.generate(this.bw)
    }

  },



  methods: {

    generate () {

      if (this.color) {
        this.backColor = this.shadeHexColor(this.color, this.bgAlpha)
        this.labelColor = this.shadeHexColor(this.color, this.labelAlpha)
      }

      let qr = {
        mode: (this.label ? 'label' : 'plain'),
        text: this.text,
        eclevel: 'H',
        minVersion: 10,
        quiet: 1,
        size: this.size,
        back: this.bw ? this.strIf(this.backColor, '#fff') : '#fff',
        label: this.strIf(this.label, null),
        fontname: 'sans',
        fontcolor: this.bw ? this.strIf(this.labelColor, '#111') : '#111',
        mSize: this.textSize
      }

      this.qrCode = kjua(qr)
    },

    bgChanged (value) {
      this.generate()
    },

    /*
     * The downloadFile code is from: https://github.com/PixelsCommander/Download-File-JS
     * (C) Copyright 2013 Denis Radin. Apache License terms.
     * Modified to ES6 standards.
    */
    downloadFile (sUrl, fileName = null) {

      // iOS devices do not support downloading. We have to inform user about this.
      if (/(iP)/g.test(navigator.userAgent)) {
        alert('Your device does not support files downloading. Please try again in desktop browser.')
        return false
      }

      // If in Chrome or Safari - download via virtual link click

//      if (this.getStore().isChrome || this.getStore().isSafari || this.getStore().isMozilla) {
        // Creating new link node.
        var link = document.createElement('a')
        link.href = sUrl

        if (link.download !== undefined) {
          // Set HTML5 download attribute. This will prevent file from opening if supported.
          var name = (fileName
            ? fileName
            : (this.fileName
              ? this.fileName
              : sUrl.substring(sUrl.lastIndexOf('/') + 1, sUrl.length))
            )
          link.download = name
        }

        // Dispatching click event.
        if (document.createEvent) {
          var e = document.createEvent('MouseEvents')
          e.initEvent('click', true, true)
          link.dispatchEvent(e)
          return true
        }
//      }

      // Force file download (whether supported by server).
      if (sUrl.indexOf('?') === -1) {
        sUrl += '?download'
      }

      window.open(sUrl, '_self')
      return true
    }

  },



  data () {
    return {
      txt: this.text,
      bw: !this.bwBackground,
      qrCode: null,
      backColor: this.color,
      labelColor: this.color
    }
  },


  created () {
    this.generate()
  }
}

</script>



// WEBPACK FOOTER //
// QrCode.vue?f0911cf8